<template>
  <div class="layouts">
    <div class="nav_content">
      <div class="left" @click="back"><i class="el-icon-arrow-left"></i></div>
      <div class="title">{{ lang.inviteFriends }}</div>
    </div>
    <div class="content-Info">
      <div class="total">
        <div class="lable">{{ lang.totalCommission }}</div>
        <div class="total-content">
          0.0
          <span>USD</span>
        </div>
      </div>
      <div class="infos">
        <p>{{ lang.tip8 }}</p>
      </div>
      <div class="link">
        <div class="link-title"></div>
        <div class="link-input">
          <div class="link-url">https://trust-savings.com#/?code=78621625</div>
          <div class="input-button">{{ lang.copy }}</div>
        </div>

      </div>
      <div class="share">🎉{{ lang.tip9 }}</div>
      <div class="icon-list">
        <div class="icon">
          <img src="../assets/images/line.svg" alt="">
        </div>
        <div class="icon">
          <img src="../assets/images/what.svg" alt="">
        </div>
        <div class="icon">
          <img src="../assets/images/tele.svg" alt="">
        </div>
        <div class="icon">
          <img src="../assets/images/facebook.svg" alt="">
        </div>
        <div class="icon">
          <img src="../assets/images/twrrite.svg" alt="">
        </div>
      </div>
    </div>

  </div>

</template>

<script type="text/javascript">
import store from "../store";
import { CONF,API_SERVER } from '@/assets/js/config'
import {mapState} from "vuex";

export default {
  data() {
    return {
      apiSer: "",
      radio: CONF.LANG ,
    }
  },
  computed: {
    ...mapState(['lang'])
  },

  methods: {
    back(){
      this.$router.back()
    },
    selectLang(){
      CONF.LANG = this.radio
      this.$indicator.open(this.lang.loading);
      sessionStorage.removeItem('lang')
      sessionStorage.setItem('lang', this.radio)
      this.$xhrGet('/system/translate').then(res => {
        store.state.lang = res.data
        this.$indicator.close();
        store.commit("SET_TRANSLATE",res.data)
        this.back()
      })

    },
  }
}
</script>


<style>
.layouts{
  background: #000;
  color: #fff;
  height: 100%;
  padding: 0 20px;
}
.nav_content {
  padding:20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_content .left{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: 600;
}
.nav_content .title{
  font-size: 20px;
  font-weight: 600;
}
.content-Info{
  height: 403px;
  padding: 32px 20px;
  background: #1a1a1a;
  border-radius: 20px;
}
.content-Info .total .lable{
  font-weight: 500;
  font-size: 14px;
  color: #ffffff4d;
}
.content-Info .total .total-content{
  font-weight: 700;
  font-size: 32px;
  margin-top: 3px;
  height: 32px;
  line-height: 32px;
}
.content-Info .total .total-content span{
  color: #c0dd2b;
}
.content-Info .infos{
  font-weight: 400;
  font-size: 14px;
  width: calc(100% - 40px);
  margin-top: 16px;
  color: #ffffff4d;
}
.content-Info .link {
  margin-top: 45px;
}
.content-Info .link .link-title{
  font-weight: 500;
  font-size: 14px;
  color: #ffffff4d;
  margin-bottom:12px;
}
.content-Info .link .link-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 6px 0 16px;
  border: 1px solid #ffffff4d;
  border-radius: 10px;
  line-height: 56px;
  position: relative;
}
.content-Info .link .link-input .link-url{
  position: absolute;
  left: 16px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.content-Info .link .link-input .input-button{
  width: 80px;
  height: 44px;
  background: #c0dd2b;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  color: #000;
  position: absolute;
  right: 4px;
}
.content-Info .share{
  font-weight: 400;
  font-size: 18px;
  margin-top: 34px;
  line-height:24px;
}
.content-Info .icon-list{
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.content-Info .icon-list .icon {
  width: 48px;
  height:48px;
}



</style>
